export enum OnboardingPopoverFeatures {
  CREATE_PATIENT = 'Create Patient',
  GP_REFERRER = 'GP Referrer',
  BUZZ_SMS = 'Buzz SMS Dashboard',
  SMS_LOG_WIDGET = 'SMS Log Widget',
}
